import { RightOutlined } from '@ant-design/icons'
import { Button, Typography } from 'antd'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ga, traceEvent } from '@/utils/ga'

import { OnboardingPageProps } from '../onboarding.interface'
import { OnboardingPageLayout } from './onboarding-page-layout.component'

export const OnboardingPage0: React.FC<OnboardingPageProps> = ({ viewer, onNext }) => {
  const { t } = useTranslation()
  const [pageStartTime, setPageStartTime] = React.useState(moment())

  // 页面停留时间
  React.useEffect(() => {
    setPageStartTime(moment())
    return () => {
      const category = traceEvent.onboarding
      ga('event', category.events.expose_time_page, {
        event_category: category.event_category,
        event_label: '0',
        value: moment().diff(pageStartTime, 'ms'),
      })
    }
  }, [])

  const img = (
    <img
      style={{ objectFit: 'contain', width: '80%', paddingRight: 0 }}
      src='https://agora-web-cdn.oss-cn-beijing.aliyuncs.com/tale/backgrounds/bg4.jpg'
    />
  )

  const left = (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {img}
      <div style={{ textAlign: 'center' }}>
        <Typography.Title level={3} style={{ marginTop: -8 }}>
          <span style={{ marginRight: 8 }}>👏</span>
          <span>
            {t('onboarding.page0.hello')}
            {viewer?.name || ''}
          </span>
          <span style={{ marginLeft: 8 }}>✨</span>
        </Typography.Title>
        <Typography.Title style={{ marginTop: 0 }} level={3}>
          {t('onboarding.page0.welcome')} <span style={{ color: '#48bbb5' }}>Tale</span>
        </Typography.Title>
      </div>
    </div>
  )

  const footer = (
    <Button
      type='primary'
      onClick={() => {
        const category = traceEvent.onboarding
        ga('event', category.events.click_next_page, {
          event_category: category.event_category,
          event_label: '0',
        })
        onNext!()
      }}
    >
      {t('onboarding.firstNext')}
      <RightOutlined type='right' />
    </Button>
  )

  return <OnboardingPageLayout left={left} footer={footer} percent={0} />
}
